import React from 'react';
import PropTypes from 'prop-types';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
// @material-ui/icons
import Clear from '@material-ui/icons/Clear';
import Check from '@material-ui/icons/Check';
// core components
import styles from '../../assets/jss/material-dashboard-react/components/customInputStyle.js';

const useStyles = makeStyles(styles);

export default function CustomInputWithIcons(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    name,
    value,
    type,
    defaultValue,
    inputProps,
    onChange,
    error,
    success
  } = props;

  return (
    <>
      <b
        {...formControlProps}
        className={formControlProps.className + ' ' + classes.formControl}
      >
        {labelText !== undefined ? (
          <TextField
            id="input-with-icon-grid"
            htmlFor={id}
            {...labelProps}
            label={labelText}
            name={name}
            type={type}
            defaultValue={defaultValue}
            className={classes.root}
            onChange={onChange}
            InputLabelProps={{
              className: classes.input_a
            }}
            value={value}
            {...inputProps}
          />
        ) : null}
        {error ? (
          <Clear className={classes.feedback + ' ' + classes.labelRootError} />
        ) : success ? (
          <Check
            className={classes.feedback + ' ' + classes.labelRootSuccess}
          />
        ) : null}{' '}
      </b>
    </>
  );
}

CustomInputWithIcons.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string,
  type: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool
};
